import { useToastContext } from "../Contexts/ToastContext";

const useNotification = () => {
  const { showNotification } = useToastContext();

  const notify = (message, variant = "info") => {
    if (message) {
      showNotification(message, variant);
    }
  };

  return notify;
};

export default useNotification;
